import { render, staticRenderFns } from "./CookingRestaurant.vue?vue&type=template&id=73e62026&"
import script from "./CookingRestaurant.vue?vue&type=script&lang=js&"
export * from "./CookingRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./CookingRestaurant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports